export default __webpack_public_path__ + "static/media/adler-fire-logo.958fedb7.webp";